import { isRejectedWithValue } from "@reduxjs/toolkit";
import { authApi } from "../services/auth";

export const error401Middleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // if (
    //   action.payload.status === 401 &&
    //   action.meta.arg.endpointName !== "logout"
    // ) {
    //   api.dispatch(authApi.endpoints.refreshToken.initiate());
    // }
	  const loginPath = window.location.pathname.startsWith("/app/") ? "/login" : "/student/login";
	  if (
		  action.payload.status === 403 &&
		  (action.payload.data.message === "Session expired" ||
			  action.payload.data.message === "Invalid token signature" ||
			  action.payload.data.message === "Token verification failed" ||
			  action.payload.data.message === "User deactivated")
	  ) {
		  window.location.href = loginPath;
	  }
	  if (
		  action.meta.arg.endpointName === "logout" &&
		  action.payload.status === 401
	  ) {
		  window.location.href = loginPath;
	  }
  }

  return next(action);
};
